6<template>
  <div>
    <titulo-formulario-instituicao-ensino :titulo="titulo" />
    <!-- Dados da Instituição -->
    <div class="mt-3">
      <h5>
        {{ $t('INSTITUICAO_ENSINO.DADOS_INSTITUICAO_ENSINO') }}
      </h5>
      <b-row class="flex-column flex-sm-row">
        <b-col cols="auto" class="col-sm-4">
          <input-text ref="nome" v-model="form.nome" label="Nome:" required />
        </b-col>
        <b-col cols="auto" class="col-sm-4">
          <input-text
            ref="razaoSocial"
            v-model="form.razaoSocial"
            label="Razão social:"
            required
          />
        </b-col>
        <b-col cols="auto" class="col-sm-4">
          <input-mask
            ref="cnpj"
            v-model="form.cnpj"
            label="CNPJ"
            type="text"
            :mask="['XX.XXX.XXX/XXXX-##']"
            :upper="true"
            placeholder="Digite o CNPJ"
          />
        </b-col>
        <b-col cols="auto" class="col-sm-9">
          <input-text
            ref="razaoSocial"
            v-model="form.municipio"
            label="Município"
            required
          />
        </b-col>
        <b-col cols="auto" class="col-sm-3">
          <input-text
            ref="razaoSocial"
            v-model="form.uf"
            label="UF"
            required
          />
        </b-col>
      </b-row>
    </div>

    <b-row>
      <b-col cols="12" class="text-right">
        <b-button variant="primary" @click="salvar">{{
          $t('GERAL.SALVAR')
        }}</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';
import InstituicaoEnsinoService from '@/common/services/instituicao-ensino/instituicao-ensino.js';

import { InstituicaoEnsino } from '@/common/models';
import { InputText, InputMask } from '@/components/inputs';
import TituloFormularioInstituicaoEnsino from '@/views/academico/outras-instituicoes/instituicao-ensino/components/TituloFormularioInstituicaoEnsino';

export default {
  components: {
    TituloFormularioInstituicaoEnsino,
    InputText,
    InputMask,
  },
  data() {
    return {
      id: this.$route.params.id,
      form: new InstituicaoEnsino({}),
    };
  },
  mounted() {
    this.id ? this.getInstituicao() : {};
  },
  computed: {
    titulo() {
      return !this.id ? this.$t('GERAL.CADASTRAR') : this.$t('GERAL.EDITAR');
    },
  },
  methods: {
    // FUNÇÕES OBTENÇÃO DE DADOS:
    getInstituicao() {
      this.$store.dispatch(START_LOADING);
      InstituicaoEnsinoService.obterInstituicaoPorId(this.id)
        .then(({ data }) => {
          this.form = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    // FUNÇÕES CRUD:
    salvar() {
      if (!this.validarFormulario()) return;
      this.form.id ? this.editar() : this.criar();
    },
    criar() {
      this.$store.dispatch(START_LOADING);
      const formCustom = { ...this.form };
      formCustom.cnpj = formCustom.cnpj?.replace(/[^0-9A-Za-z]/g, '');
      InstituicaoEnsinoService.criar(formCustom)
        .then((e) => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), e.data.mensagem);
          this.$router.push({
            name: 'instituicao-ensino'
          })
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    editar() {
      this.$store.dispatch(START_LOADING);
      const formCustom = { ...this.form };
      formCustom.cnpj = formCustom.cnpj?.replace(/[^0-9A-Za-z]/g, '');
      InstituicaoEnsinoService.editar(formCustom)
        .then(() => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), 'Instituição editada!');
          this.$router.push({ name: 'instituicao-ensino' });
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },
  },
};
</script>
